'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = snakeCaseObjectKeys;

var _lodash = require('lodash.snakecase');

var _lodash2 = _interopRequireDefault(_lodash);

var _transformObjectKeys = require('./transformObjectKeys');

var _transformObjectKeys2 = _interopRequireDefault(_transformObjectKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function snakeCaseObjectKeys(object) {
  return (0, _transformObjectKeys2.default)(object, _lodash2.default);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zbmFrZUNhc2VPYmplY3RLZXlzLmpzIl0sIm5hbWVzIjpbInNuYWtlQ2FzZU9iamVjdEtleXMiLCJvYmplY3QiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUd3QkEsbUI7O0FBSHhCOzs7O0FBQ0E7Ozs7OztBQUVlLFNBQVNBLG1CQUFULENBQTZCQyxNQUE3QixFQUFxQztBQUNsRCxTQUFPLG1DQUFvQkEsTUFBcEIsbUJBQVA7QUFDRCIsImZpbGUiOiJzbmFrZUNhc2VPYmplY3RLZXlzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHNuYWtlQ2FzZSBmcm9tICdsb2Rhc2guc25ha2VjYXNlJ1xuaW1wb3J0IHRyYW5zZm9ybU9iamVjdEtleXMgZnJvbSAnLi90cmFuc2Zvcm1PYmplY3RLZXlzJ1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzbmFrZUNhc2VPYmplY3RLZXlzKG9iamVjdCkge1xuICByZXR1cm4gdHJhbnNmb3JtT2JqZWN0S2V5cyhvYmplY3QsIHNuYWtlQ2FzZSlcbn1cbiJdfQ==